import { useCallback, useEffect, useRef, useState } from 'react';

import { Tabs, Swiper } from 'antd-mobile';
import { SwiperRef } from 'antd-mobile/es/components/swiper';
import { Column } from 'farmhub-ui-core';
import { useHistory } from 'react-router-dom';

import { CSwiper, CTabs } from './styles';

interface TabPanelProps {
  children?: React.ReactNode;
  tab?: React.ReactNode;
  key?: React.ReactNode;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
}

interface TabsProps {
  children?: React.ReactNode | React.ReactNode[];
  heightTop?: number;
  tabLocation?: number;
  allowTouchMove?: boolean;
  styles?: any;
  active?: number;
  className?: string;
  isChangeTab?: boolean;
  onChangeTab?: (val: number) => void;
}

export const TabPanel = ({
  children,
  tab,
  key,
  style,
  icon,
}: TabPanelProps): JSX.Element => {
  const dev = useRef(null);

  return (
    <div ref={dev} style={{ minHeight: '280px', ...style }}>
      {children}
    </div>
  );
};

export const TabsMobile = ({
  children,
  heightTop = 0,
  tabLocation,
  active = 0,
  allowTouchMove = true,
  styles = {},
  className = '',
  isChangeTab,
  onChangeTab,
}: TabsProps): JSX.Element => {
  // const { tab = 0 } = router.query;
  const history = useHistory();
  const tab = active ?? 0;
  const swiperRef = useRef<SwiperRef>(null);
  const [activeIndex, setActiveIndex] = useState(tabLocation || 0);
  const [childOffsetHeight, setChildOffsetHeight] = useState(0);
  const [isProductTabActive, setIsProductTabActive] = useState(true);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const childHeight: number[] = [];

  useEffect(() => {
    if (tabLocation != null && tabLocation != activeIndex) {
      setActiveIndex(tabLocation);

      if (swiperRef) {
        swiperRef.current?.swipeTo(tabLocation);
      }
    }
  }, [tabLocation]);

  useEffect(() => {
    if (active != activeIndex && swiperRef?.current) {
      setActiveIndex(active);
      swiperRef.current?.swipeTo(active);
    }
  }, [active]);

  const _handleChangePage = useCallback((index: number, isFirst?: boolean) => {
    if (index === 0) {
      setIsProductTabActive(true);
    } else setIsProductTabActive(false);

    onChangeTab && onChangeTab(index);

    if (scrollRef?.current?.offsetTop && !isFirst) {
      window.scrollTo({
        top: scrollRef?.current?.offsetTop - heightTop,
        behavior: 'smooth',
      });
    }

    const arrayElement = document.getElementsByClassName(
      `adm-swiper-item-child ${className}`
    );

    if (arrayElement) {
      const activeElement: HTMLElement = arrayElement[index] as HTMLElement;

      for (let i = 0; i < arrayElement.length; i++) {
        if (i !== index) {
          const child: HTMLElement = arrayElement[i] as HTMLElement;

          if (childHeight.length <= arrayElement.length - 1) {
            childHeight.push(child.offsetHeight);
          }
          const minChildHeight = Math.min(...childHeight);
          setChildOffsetHeight(minChildHeight);

          if (tabLocation) {
            child.style.height =
              childOffsetHeight > 0 ? `${childOffsetHeight}px` : '100%';
          } else {
            child.style.height = `${childOffsetHeight}px`;
          }
        } else {
          if (
            index === 0 &&
            history.location.pathname.includes('/digital-menu')
          ) {
            activeElement.style.height = 'unset';
          } else activeElement.style.height = 'fit-content';
        }
      }
    }

    setActiveIndex(index);
  }, []);

  useEffect(() => {
    _handleChangePage(activeIndex, true);
  }, [_handleChangePage, activeIndex]);

  const _convertChild = () => {
    if (typeof children == 'object') {
      if (Object.prototype.toString.call(children) === '[object Array]')
        return [...(children as React.ReactNode[])];

      return [children];
    }

    return [];
  };

  const _activeValue = (value: any): any => {
    const activeKey = value;

    if (activeKey) {
      return activeKey.key;
    }
    return '';
  };

  const genTitle = (
    title: string,
    icon: any,
    activated: boolean
  ): JSX.Element => (
    <Column alignItems="center">
      {icon && icon(activated)}
      <span>{title}</span>
    </Column>
  );

  return (
    <>
      <div
        ref={scrollRef}
        style={{
          scrollMarginTop: '50px',
          ...styles,
          transition: 'all 0.4s ease 0.4s',
        }}
      >
        <CTabs
          activeKey={_activeValue(_convertChild()[activeIndex])}
          defaultActiveKey={String(tab)}
          onChange={key => {
            const index = _convertChild().findIndex(
              (item: any) => item.key === key
            );

            setActiveIndex(index);
            swiperRef.current?.swipeTo(index);

            onChangeTab && onChangeTab(index);

            if (scrollRef) {
              scrollRef?.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
              });
            }
          }}
        >
          {_convertChild().map((item: any) => (
            <Tabs.Tab
              key={item.key}
              title={genTitle(
                item?.props?.tab,
                item?.props?.icon,
                _activeValue(_convertChild()[activeIndex]) === item.key
              )}
            />
          ))}
        </CTabs>
      </div>
      <CSwiper
        ref={swiperRef}
        loop
        allowTouchMove={allowTouchMove}
        defaultIndex={Number.parseInt(String(tab), 10) || activeIndex}
        direction="horizontal"
        indicator={() => null}
        isProductTabActive={isProductTabActive}
        onIndexChange={_handleChangePage}
      >
        {_convertChild().map((item: any, index: number) => (
          <Swiper.Item>
            <div className={`adm-swiper-item-child ${className}`}> {item}</div>
          </Swiper.Item>
        ))}
      </CSwiper>
    </>
  );
};
